import React, { useEffect, useState } from "react";
import { Minus, Plus } from "@phosphor-icons/react";

/**
 * Cantidad de etiquetas con botones − / + propios (en lugar del <input type="number"> nativo, cuyas
 * flechitas se comportan distinto en cada navegador) y un campo que SÍ se puede vaciar para escribir
 * otro número. Al salir del campo, si quedó vacío o inválido, vuelve al último valor válido.
 */
export default function QuantityInput({ value, onChange, min = 1, max = 5000, testId }) {
    const [text, setText] = useState(String(value));

    useEffect(() => {
        setText(String(value));
    }, [value]);

    const clamp = (n) => Math.min(max, Math.max(min, n));

    function commit(raw) {
        const n = parseInt(raw, 10);
        const next = Number.isFinite(n) ? clamp(n) : value;
        setText(String(next));
        onChange(next);
    }

    function handleChange(e) {
        const digits = e.target.value.replace(/\D/g, "").slice(0, 5);
        setText(digits);
        const n = parseInt(digits, 10);
        if (Number.isFinite(n) && n >= min) onChange(clamp(n)); // vacío o menor al mínimo: espera a que termine de escribir
    }

    function handleKeyDown(e) {
        if (e.key === "ArrowUp") {
            e.preventDefault();
            commit(String(value + 1));
        } else if (e.key === "ArrowDown") {
            e.preventDefault();
            commit(String(value - 1));
        } else if (e.key === "Enter") {
            e.currentTarget.blur();
        }
    }

    const btn =
        "w-8 flex items-center justify-center bg-white border border-brand-300 text-brand-900 hover:bg-brand-100 disabled:opacity-40 disabled:cursor-not-allowed";
    return (
        <div className="inline-flex items-stretch" translate="no">
            <button type="button" aria-label="Menos etiquetas" onClick={() => commit(String(value - 1))} disabled={value <= min} className={`${btn} border-r-0`}>
                <Minus size={14} />
            </button>
            <input
                data-testid={testId}
                type="text"
                inputMode="numeric"
                autoComplete="off"
                value={text}
                onChange={handleChange}
                onBlur={() => commit(text)}
                onKeyDown={handleKeyDown}
                onFocus={(e) => e.target.select()}
                className="w-20 text-center bg-white border border-brand-300 text-brand-950 text-sm rounded-none px-2 py-1.5 font-mono focus:outline-none focus:border-brand-900"
            />
            <button type="button" aria-label="Más etiquetas" onClick={() => commit(String(value + 1))} disabled={value >= max} className={`${btn} border-l-0`}>
                <Plus size={14} />
            </button>
        </div>
    );
}
